import api from './api';
export const authService = {
  async login(email, password){//, email_honeypot = '', recaptcha_token = '', turnstile_token = '') {
    const response = await api.post('/auth/login', {
      login: email,
      password
      //email_honeypot,
      //recaptcha_token,
      //turnstile_token
    });
    return response.data;
  },
  async register(userData) {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },
  async verifyEmail(token) {
    const response = await api.get(`/auth/verify-email/${token}`);
    return response.data;
  },
  async forgotPassword(email) {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },
  async resetPassword(token, newPassword) {
    const response = await api.post(`/auth/reset-password/${token}`, { password: newPassword });
    return response.data;
  },
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
  getCurrentUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
  isAuthenticated() {
    return !!localStorage.getItem('token');
  }
};